module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 167.b41bb2ed.png";